module.exports = __webpack_public_path__ + "img/checked-shield-icon.e0496fa9.svg";